import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RegisterPage from "./pages/Register";
import LoginPage from "./pages/Login";
import SubscriptionPage from "./pages/Subscription";
import Success from "./pages/Subscription/success";
import Cancel from "./pages/Subscription/cancel";

const RoutesPage = () => (
  <Router>
    <Routes>
      {/* Routes without Header */}
      <Route path="/" element={<SubscriptionPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/subscribe" element={<SubscriptionPage />} />
      <Route path="/success" element={<Success />} />
      <Route path="/cancel" element={<Cancel />} />
    </Routes>
  </Router>
);

export default RoutesPage;
